module.exports = __webpack_public_path__ + "img/Montserrat.57cb3b44.svg";